import { wordSimplified } from 'utils/helperFunction'

const ENDS_SENTENCE = /[。！？!?…]$/
const CLOSING = /^[”"』」）)]+$/
const MAX_WORDS = 60

const squash = (s: string) => s.replace(/\s+/g, '')

/**
 * Cuts the tapped line (a whole paragraph on the story page) down to the sentence the word is in.
 * `exact` is the reader's own sentence text when the page knows it, which settles a word that
 * appears in more than one sentence.
 */
export function sliceSentence(words: string[] | undefined, word: string, exact?: string | null): string[] {
  const tokens = (words || []).filter(Boolean)
  const sentences: string[][] = []
  let current: string[] = []
  tokens.forEach((t) => {
    if (CLOSING.test(t) && !current.length && sentences.length) {
      sentences[sentences.length - 1].push(t)
      return
    }
    current.push(t)
    if (ENDS_SENTENCE.test(t)) {
      sentences.push(current)
      current = []
    }
  })
  if (current.length) sentences.push(current)

  const target = wordSimplified(word)
  const byText = exact ? sentences.find((s) => squash(s.join('')) === squash(exact)) : undefined
  const byWord = sentences.find((s) => s.some((t) => wordSimplified(t) === target))
  return (byText || byWord || sentences[0] || []).slice(0, MAX_WORDS)
}

/** The first definition as plain text, for the one-line meaning in the pocket. */
export function plainMeaning(html: string | undefined) {
  if (!html) return ''
  const div = document.createElement('div')
  div.innerHTML = html
  return (div.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 300)
}
